import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQueryWithRedirect = (baseUrl) => {
    const baseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('access_token');
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    });

    return async (args, api, extraOptions) => {
        try {
            const result = await baseQuery(args, api, extraOptions);
            
            if (result?.error) {
                const { status } = result.error;
                if (status === 401) {
                    window.location.href = '/login';
                }
                if (status === 403) {
                    window.location.href = '/no-access';
                }
            }
            return result;
        } catch (error) {
            console.log(error)
            
        }


    };
};

// Reusable function to create APIs with consistent config
export const createApiConfig = (baseUrl) => ({
    baseQuery: baseQueryWithRedirect(baseUrl),
});
